import React from 'react';

import { gray } from 'utils/style/colors';

import { ChevronSVG } from './styles';

interface IChevronProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  height?: number;
  isOpen: boolean;
  width?: number;
  forwardRef?:
    | ((instance: SVGSVGElement | null) => void)
    | React.RefObject<SVGSVGElement>
    | null
    | undefined;
}

const Chevron: React.FC<IChevronProps> = ({
  fill = gray,
  height = 20,
  isOpen,
  width = 20,
  forwardRef,
  ...restProps
}) => {
  return (
    <ChevronSVG
      height={height}
      isOpen={isOpen}
      viewBox="0 0 32 32"
      width={width}
      ref={forwardRef as any}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <svg></svg>
      <path
        fill={fill}
        d="M16.003 18.626l7.081-7.081L25 13.46l-8.997 8.998-9.003-9 1.917-1.916z"
      />
    </ChevronSVG>
  );
};

export default Chevron;
